import { State, useState } from "@hookstate/core"
import { useTableData } from "./context"

export function useRow<T>(rowId: string): State<T> {
  const ctx = useTableData<T>()
  const g = useState(ctx.state.data)
  const row = g[rowId]
  return row
}
